<template>
  <div class="form-group">
    <label
      for="pdp-modal-rpa-search-input"
      qaid="pdp-modal-rpa-search-input-label"
      class="form-label"
      v-html="bp('retailerStorelocatorQuery')"
    />
    <div class="form-group--inline relative">
      <i class="material-icons md-24 absolute rpa-modal__search-icon">location_on</i>
      <input
        id="pdp-modal-rpa-search-input"
        v-model="zipCode"
        type="text"
        name="pdp-modal-rpa-search-input"
        class="form-control pl-5"
        qaid="pdp-modal-rpa-search-input"
        @keyup.enter="search"
      />
      <trek-button primary form-inline qaid="pdp-modal-rpa-search-button" @click="search">
        <span v-html="bp('retailerTextSearch')" />
      </trek-button>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import {Cookie} from '@/utils/cookie';
import {retailerActions} from '@/store/modules/retailer-search';
export default {
  name: 'PdpRpaModalSearch',
  components: {TrekButton},
  props: {
    value: {
      type: String,
      default: '',
      required: false,
    },
    retailerData: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      zipCode: this.retailerData.locationPostalCode || Cookie.get('trek_rpa_user_search_phrase'),
    };
  },
  watch: {
    zipCode(value) {
      this.$store.dispatch(retailerActions.UPDATE_LOCATION, {location: value});
    },
    value() {
      this.zipCode = this.value;
    },
  },
  mounted() {
    this.zipCode = this.value;
  },
  methods: {
    search() {
      if (this.zipCode == '') {
        this.zipCode = this.retailerData.locationPostalCode;
      }
      this.$emit('search', this.zipCode);
    },
  },
};
</script>
